import React, { useEffect, useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { toast } from "sonner";
import api from "../lib/api";
import { useLang } from "../lib/i18n";

export function PayPalPay({ orderId, onPaid }) {
  const { t } = useLang();
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    api.get("/payments/methods").then((r) => setCfg(r.data)).catch(() => setCfg({ paypal: false }));
  }, []);

  if (!cfg?.paypal || !cfg?.paypal_client_id) return null;

  return (
    <div data-testid="paypal-pay">
      <div className="my-1 flex items-center gap-3 text-xs font-semibold uppercase text-slate-400">
        <span className="h-px flex-1 bg-slate-200" />{t("or")}<span className="h-px flex-1 bg-slate-200" />
      </div>
      <PayPalScriptProvider options={{ clientId: cfg.paypal_client_id, currency: "EUR", intent: "capture" }}>
        <PayPalButtons
          style={{ layout: "vertical", color: "gold", shape: "pill", label: "paypal", height: 48 }}
          createOrder={async () => {
            const { data } = await api.post("/payments/paypal/create", { order_id: orderId });
            return data.paypal_order_id;
          }}
          onApprove={async (data) => {
            try {
              const res = await api.post("/payments/paypal/capture", { paypal_order_id: data.orderID });
              if (res.data.status === "paid") { toast.success(t("payment_ok")); onPaid?.(); }
            } catch (e) {
              toast.error(t("payment_cancel"));
            }
          }}
          onError={() => toast.error(t("payment_cancel"))}
        />
      </PayPalScriptProvider>
    </div>
  );
}
